(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('inputSelect', input);

    input.$inject = ['$timeout'];

    function input($timeout) {
        
        return {
            restrict: 'C',
            scope: false,
            link: function(scope, element, attrs){
                
                var tooltipElement = element[0].parentNode.getElementsByClassName('tooltip')[0];

                

                if(!tooltipElement) {return;}
                
                element.on('mouseenter', setTooltip);

                function setTooltip(){
                    var overflowElement = element[0].getElementsByClassName('tooltip-overflow')[0];

                    overflowElement = overflowElement ? overflowElement : element[0];
                    if(overflowElement.scrollWidth - overflowElement.offsetWidth > 0){
                        tooltipElement.classList.add('overflow');
                    }else{
                        tooltipElement.classList.remove('overflow');
                    }
                }
            }
        };
    }
})();